export default  {
    knobX: 71.08,
    knobY: 71.08,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="204px" height="204px" viewBox="0 0 204 204" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="49d33e31-bf4d-a753-1175-c0858608ad59">
            <stop stop-color="#444040" stop-opacity="0.51098279" offset="0%"/>
            <stop stop-color="#131111" stop-opacity="0.893200861" offset="100%"/>
        </linearGradient>
        <circle id="b0e61d25-9751-2709-77c2-43a0d2765ac0" cx="98.0392157" cy="98.0392157" r="98.0392157"/>
        <filter x="-3.3%" y="-3.3%" width="106.6%" height="106.6%" filterUnits="objectBoundingBox" id="c8076758-005f-b1c9-8186-859994ef4604">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="0" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="9d79eb1c-be7e-e08b-0a27-94fe49e73955">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="47a738eb-6ad0-d5fd-c2aa-aec25060f3c8" cx="98" cy="98" r="86"/>
        <filter x="-4.1%" y="-3.5%" width="108.1%" height="108.1%" filterUnits="objectBoundingBox" id="31a63d60-9dcb-f39f-f64a-841ad0f35b2a">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="b0c4faeb-4cbc-946b-d29b-9175d733b39b" cx="71.0784314" cy="71.0784314" r="71.0784314"/>
        <filter x="-8.8%" y="-8.8%" width="117.6%" height="117.6%" filterUnits="objectBoundingBox" id="974cc517-2740-3d43-3f9c-1d54da4dc4b9">
            <feGaussianBlur stdDeviation="10" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0.639215686   0 0 0 0 0.784313725   0 0 0 0 0.956862745  0 0 0 1 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <path d="M71.5,6.35149137 L88,67.4498536 C83.2378045,69.1012512 77.7378045,69.946758 71.5,69.986374 C65.2621955,70.02599 59.7621955,69.1804832 55,67.4498536 L71.5,6.35149137 Z" id="017c3ebb-7dbc-8e3a-f3b1-e494f4fa7ff8"/>
        <filter x="-71.2%" y="-33.8%" width="242.4%" height="173.9%" filterUnits="objectBoundingBox" id="1dac708c-6252-fad4-d1b2-7c24c1b02857">
            <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="7.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.639215686   0 0 0 0 0.784313725   0 0 0 0 0.956862745  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s14" transform="translate(4.000000, 4.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#c8076758-005f-b1c9-8186-859994ef4604)" xlink:href="#b0e61d25-9751-2709-77c2-43a0d2765ac0"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#49d33e31-bf4d-a753-1175-c0858608ad59)" fill-rule="evenodd" xlink:href="#b0e61d25-9751-2709-77c2-43a0d2765ac0"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#31a63d60-9dcb-f39f-f64a-841ad0f35b2a)" xlink:href="#47a738eb-6ad0-d5fd-c2aa-aec25060f3c8"/>
                    <use fill="" fill-rule="evenodd" xlink:href="#47a738eb-6ad0-d5fd-c2aa-aec25060f3c8"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="url(#9d79eb1c-be7e-e08b-0a27-94fe49e73955)" fill-rule="evenodd" xlink:href="#47a738eb-6ad0-d5fd-c2aa-aec25060f3c8"/>
                </g>
                <g id="knob" transform="translate(26.431373, 26.431373)">
                    <g id="Oval-5">
                        <use fill="#322E2E" fill-rule="evenodd" xlink:href="#b0c4faeb-4cbc-946b-d29b-9175d733b39b"/>
                        <use fill="black" fill-opacity="1" filter="url(#974cc517-2740-3d43-3f9c-1d54da4dc4b9)" xlink:href="#b0c4faeb-4cbc-946b-d29b-9175d733b39b"/>
                        <use stroke="#A3C8F4" stroke-width="5" xlink:href="#b0c4faeb-4cbc-946b-d29b-9175d733b39b"/>
                    </g>
                    <g id="Rectangle-Copy-2" transform="translate(71.500000, 38.169598) scale(1, -1) translate(-71.500000, -38.169598) ">
                        <use fill="black" fill-opacity="1" filter="url(#1dac708c-6252-fad4-d1b2-7c24c1b02857)" xlink:href="#017c3ebb-7dbc-8e3a-f3b1-e494f4fa7ff8"/>
                        <use fill="#A3C8F4" fill-rule="evenodd" xlink:href="#017c3ebb-7dbc-8e3a-f3b1-e494f4fa7ff8"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`
}